import { Chip, ChipProps } from '@mui/material';
import React from 'react';

export function PositionChip({
  label,
  ...props
}: { label: string } & ChipProps) {
  return (
    <Chip
      label={label}
      style={{
        fontSize: 12,
        lineHeight: '18px',
        padding: '2px 4px',
        borderRadius: 2,
      }}
      {...props}
    />
  );
}
